import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('questions', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`questions/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('questions', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`questions/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`questions/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        types: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('types', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        questionnaires: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('questionnaires', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        season_questionnaires: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('season_questionnaires', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        projects: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('projects', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
